export default "__VITE_ASSET__DkYz000P__"